import Vue from 'vue'
import router from '@/router'
import "@/libs/vant-use"
Vue.config.productionTip = false
import {
  wxSetTitle
} from '@/libs/title'
import api from './http/index'
Vue.use(api)
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
    wxSetTitle(to.meta.title)
  }
  next()
})
try {
  new Vue({
    el: '#app',
    router,
    // template: '<App/>'
    template: '<router-view></router-view>'
  })
} catch (e) {

}



// WEBPACK FOOTER //
// ./src/main.js